import utils from "../utils";
import Splide from '@splidejs/splide';

function init() {

	var productCarousels = document.querySelectorAll('.product-carousel.splide');

    if(productCarousels.length > 0){
        utils.forEach(productCarousels, function (index, elem) {
			
			var productCarousel = new Splide(elem, { // eslint-disable-line no-unused-vars
				type: 'slide',
				perPage: 1,
				pagination: true,
				arrows: false,
				updateOnMove: true,
				perMove: 1,
				rewindByDrag: false,
				rewind: false,
				arrowPath: "m25.51.5c-.71.7-.71,1.84-.01,2.56l8.44,8.46H1.8C.81,11.52,0,12.33,0,13.33c0,1,.81,1.8,1.8,1.8h32.13l-8.44,8.47c-.69.71-.69,1.85.01,2.56.71.7,1.84.69,2.54-.01,0,0,0,0,0,0l11.45-11.53h0c.16-.17.28-.36.38-.57.09-.22.14-.46.14-.7,0-.47-.18-.93-.51-1.26L28.04.55c-.68-.71-1.8-.74-2.51-.06,0,0-.01,0-.02.01Z",
				classes: {
					// Add classes for arrows.
					arrows: "smx-navigation",
					arrow: "smx-nav",
					prev: "prev carousel-prev magic-hover",
					next: "next carousel-next magic-hover",
					pagination: "smx-pagination",
					page: "smx-dot",
				},
			})

			productCarousel.mount();

		});
    }

}

export default { init };
